(ns hypnos.backoffice.core.auth
  "Function for authentication & authorization."
  (:require [clojure.string :as str]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; API

(defn iris-sleep-user?
  "Returns true is the current user is a Iris Sleep user"
  [{:keys [_user groups] :as _auth}]
  (some #(str/starts-with? % "hypnos-superuser-group") groups))

(defn authorized?
  "Checks is the current user has the permission, i.e is authorized to perform the
  associated action."
  [{:keys [_user _groups] :as auth} permission]
  (case permission
    :cancel-consult        (not (iris-sleep-user? auth))
    :create-new-consult    (not (iris-sleep-user? auth))
    :edit-patient          (not (iris-sleep-user? auth))
    :make-recommendation   (iris-sleep-user? auth)
    :select-recommendation (not (iris-sleep-user? auth))
    :send-message          (not (iris-sleep-user? auth))
    false))
